import points from "./points.svg";
import closeRed from "./close-red.svg";
import lock from "./lock.svg";
import xpicon from "./exp-con.svg";
import linkOpen from "./linkopen.svg";
import nextArrow from "./proximo.svg";
import backArrow from "./regresar.svg";
import mobileIconInsignias from "./insign_mobile_icon.svg";
import landscape_icons from "./landscapeLogo.svg";
import dialogBallon from "./dialog.svg";
import home from "./home.svg";
import arrow from "./arrow-uturn-left.svg";
import scrollHand from "./scroll-hand.svg";
import sliceHand from "./slice-hand.svg";
import touchHand from "./touch-hand.svg";
import pause from "./pause.svg";
import pauseHand from "./pause-hand.svg";
import HandhleiconMenu from "./heroicons-outline-bars-3.svg";
import flujo_trabajo from "./flujo-de-trabajo-1.svg";
import grafico_circular from "./grafico-circular-1.svg";
import grupo_chat from "./grupo-de-chat-1.svg";
import satisfaccion_cliente from "./la-satisfaccion-del-cliente-1.svg";
import herramientas_de_compra from "./shopin__cart.svg";
import etiqueteo from "./etiqueteo.svg";
import portales from "./portales.svg";
import arrowFloor from "./arrowfloor.svg";
import agitar from "./Agitar.svg";
import flechaabajo from "./flechaabajo.svg";
import exit from "./exit.svg";
import insig from "./insig.svg";
import book from "./libro.svg";
import arrowmenu from "./flecha.svg";
import threepoints from "./trespuntos.svg";
import threepointswhite from "./threepointswhite.svg";
import padlocks from "./candado.svg";
import padlockblack from "./padlockblack.svg";
import iconnottask from "./iconnottask.svg";
import blackerrornotask from "./blackerrornotask.svg";
import chica_oxxo from "./chica_oxxo.svg";
import chico_oxxo from "./chico_oxxo.svg";
import alerta from "./alerta.svg";
import play from "./play.svg";
import soundOff from "./soundOff.svg";
import soundOn from "./soundOn.svg";
import male from "./male.png";
import female from "./female.png";
import logooxxo from "./logooxxo.svg";
import backinsg from "./backinsg.svg";
import iconhand from "./iconhand.svg";
import returnbutton from "./returnbutton.svg";

export const icons = {
	returnbutton,
	soundOff,
	soundOn,
	backinsg,
	logooxxo,
	male,
	female,
	play,
	alerta,
	chica_oxxo,
	chico_oxxo,
	iconnottask,
	blackerrornotask,
	arrowmenu,
	threepoints,
	threepointswhite,
	padlocks,
	padlockblack,
	book,
	exit,
	insig,
	points,
	closeRed,
	arrowFloor,
	landscape_icons,
	nextArrow,
	backArrow,
	lock,
	xpicon,
	mobileIconInsignias,
	linkOpen,
	dialogBallon,
	home,
	arrow,
	scrollHand,
	sliceHand,
	touchHand,
	pause,
	pauseHand,
	HandhleiconMenu,
	flujo_trabajo,
	grafico_circular,
	grupo_chat,
	satisfaccion_cliente,
	herramientas_de_compra,
	etiqueteo,
	portales,
	agitar,
	flechaabajo,
	iconhand
};
